exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pricing-plan[data-v-2154c713] {\n    border: solid 1px #d64571;\n    flex-basis: 0;\n    flex-grow: 1;\n}\n.save-tag[data-v-2154c713] {\n    position: absolute;\n    right: -1rem;\n    top: 1rem;\n    z-index: 2;\n    background-color: #fff1c3;\n}\n", ""]);

// exports
